// extracted by mini-css-extract-plugin
export default {"ModeCard":"ServerPreview_ModeCard__2pVHy","ModeInfos":"ServerPreview_ModeInfos__+Jqs0","title":"ServerPreview_title__bvaN5","description":"ServerPreview_description__UafRF"};